import Cookies from 'js-cookie';
import { defineStore } from 'pinia';

import { type UserTokens, type UserTokensState } from './userTokensState';

export const userTokensCookieName = 'x-wspomnienia-z-wesela-user-tokens';

export const useUserTokensStore = defineStore('userTokens', {
  state: (): UserTokensState => {
    const existsCookieUserTokens = Cookies.get(userTokensCookieName);

    let userTokensValue: UserTokens | null = null;

    if (existsCookieUserTokens) {
      const parsedCookieUserTokens = JSON.parse(existsCookieUserTokens) as UserTokens;

      userTokensValue = parsedCookieUserTokens;
    }

    return {
      userTokens: userTokensValue,
    };
  },
  getters: {
    getLoggedInUserTokens(): UserTokens | null {
      return this.userTokens ?? null;
    },
    getLoggedInUserAccessToken(): string | null {
      return this.userTokens?.accessToken ?? null;
    },
    getLoggedInUserRefreshToken(): string | null {
      return this.userTokens?.refreshToken ?? null;
    },
  },
  actions: {
    setUserTokens(userTokens: UserTokens): void {
      this.userTokens = userTokens;

      Cookies.set(userTokensCookieName, JSON.stringify(userTokens), {
        expires: 7,
        sameSite: 'Strict',
      });
    },
    removeUserTokens(): void {
      this.userTokens = null;

      Cookies.remove(userTokensCookieName);
    },
  },
});
